function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #ed7ee0;\n      }\n\n      .cls-1, .cls-2, .cls-3, .cls-4 {\n        mix-blend-mode: multiply;\n      }\n\n      .cls-1, .cls-2, .cls-3, .cls-5, .cls-6, .cls-7, .cls-8 {\n        stroke-width: 0px;\n      }\n\n      .cls-2, .cls-6 {\n        fill: #0f9965;\n      }\n\n      .cls-3 {\n        fill: #125931;\n      }\n\n      .cls-9 {\n        isolation: isolate;\n      }\n\n      .cls-5 {\n        fill: #0f3299;\n      }\n\n      .cls-7 {\n        fill: #69d6a2;\n      }\n\n      .cls-8 {\n        fill: #00aeef;\n      }\n    "));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  className: "cls-9"
}, /*#__PURE__*/React.createElement("g", {
  id: "Layer_2",
  "data-name": "Layer 2"
}, /*#__PURE__*/React.createElement("g", {
  id: "Layer_1-2",
  "data-name": "Layer 1"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "m573.75,274.72c-.7-.42-1.39-.86-2.17-1.19l-151.5-64.4c-.13-.05-.26-.08-.38-.12l52.78,87.37,101.27-21.66Zm6.15,6.95l-111.4,23.83-58.65-97.12c-4.75,1.19-8.94,4.47-11,9.31l-38.03,89.45c-3.49,8.21.33,17.72,8.57,21.23l151.49,64.4c8.23,3.5,17.75-.35,21.24-8.56l38.03-89.44c1.85-4.36,1.59-9.09-.25-13.1Z"
}), /*#__PURE__*/React.createElement("g", {
  className: "cls-4"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-8",
  d: "m403.33,321.04l-159.43,61.69c-18.67,7.23-39.74-2.09-46.96-20.76l-33.85-87.48c-7.23-18.67,2.09-39.74,20.76-46.96l159.43-61.69c18.67-7.23,39.74,2.09,46.96,20.76l33.85,87.48c7.22,18.67-2.09,39.74-20.76,46.96Zm-210.75-70.93c-6.22,2.41-9.33,9.43-6.92,15.65l33.85,87.48c2.41,6.22,9.43,9.33,15.65,6.92l159.43-61.69c6.22-2.41,9.33-9.43,6.92-15.65l-33.85-87.48c-2.41-6.22-9.43-9.33-15.65-6.92l-159.43,61.69Z"
})), /*#__PURE__*/React.createElement("g", {
  className: "cls-4"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-8",
  d: "m435.54,379.13l-176.36,68.24c-14,5.42-29.8-1.56-35.22-15.57s1.56-29.8,15.57-35.22l176.36-68.24c14-5.42,29.8,1.57,35.22,15.57,5.42,14-1.56,29.8-15.57,35.22Zm-187.28,40.02c-1.55.6-2.33,2.36-1.73,3.92.6,1.55,2.36,2.33,3.91,1.73l176.36-68.24c1.55-.6,2.33-2.36,1.73-3.91s-2.36-2.33-3.91-1.73l-176.36,68.24Z"
})), /*#__PURE__*/React.createElement("g", {
  className: "cls-4"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-5",
  d: "m56.32,237.04c-2.74,1.18-4,4.36-2.82,7.1,1.19,2.74,4.36,4,7.1,2.82,16.43-7.09,35.56.5,42.66,16.92.59,1.37,1.68,2.37,2.97,2.88,1.29.51,2.76.53,4.13-.06,2.74-1.18,4-4.36,2.81-7.1-9.45-21.89-34.96-32.01-56.85-22.55Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-5",
  d: "m123.14,258.07c1.28.51,2.76.53,4.13-.07,2.74-1.18,4-4.36,2.81-7.1-13.32-30.85-49.27-45.12-80.12-31.79-2.73,1.19-4,4.36-2.82,7.1,1.19,2.74,4.37,4,7.1,2.82,25.39-10.96,54.96.77,65.93,26.16.58,1.37,1.68,2.37,2.96,2.88Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-5",
  d: "m147.99,243.17c-8.52-19.73-24.21-34.96-44.19-42.88-19.98-7.92-41.84-7.6-61.57.92-2.74,1.18-4,4.36-2.82,7.1,1.18,2.74,4.36,4,7.1,2.82,35.26-15.23,76.33,1.06,91.56,36.33.6,1.37,1.68,2.36,2.97,2.87,1.28.51,2.76.53,4.13-.06,2.74-1.18,4-4.36,2.82-7.1Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-5",
  d: "m92.11,312.68c2.74-1.18,4-4.36,2.82-7.1-1.19-2.74-4.36-4-7.1-2.82-16.43,7.09-35.56-.5-42.66-16.93-.59-1.37-1.68-2.37-2.96-2.88-1.29-.51-2.76-.53-4.13.06-2.74,1.18-4,4.36-2.82,7.1,9.45,21.89,34.95,32.01,56.85,22.55Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-5",
  d: "m98.47,330.6c2.74-1.18,4-4.36,2.82-7.1-1.19-2.74-4.36-4-7.1-2.82-25.38,10.96-54.96-.77-65.93-26.16-.59-1.37-1.68-2.37-2.96-2.88-1.28-.51-2.76-.53-4.13.07-2.74,1.18-4,4.36-2.82,7.1,13.33,30.85,49.27,45.11,80.12,31.79Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-5",
  d: "m101.92,338.58c-35.26,15.23-76.33-1.06-91.56-36.32-.6-1.37-1.69-2.37-2.97-2.88-1.29-.51-2.76-.53-4.13.06-2.74,1.18-4,4.36-2.82,7.1,8.52,19.73,24.21,34.96,44.18,42.88,19.98,7.92,41.84,7.59,61.57-.92,2.74-1.18,4-4.36,2.81-7.1-1.18-2.74-4.36-4-7.1-2.82Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-5",
  d: "m81.68,256.06c-10.5-4.17-22.39.97-26.55,11.47-4.17,10.5.97,22.39,11.47,26.56,8.13,3.22,17.08.86,22.64-5.25l40.54,22.59,10.01-25.24-45.21-11.41c-.11-8.03-4.98-15.57-12.9-18.71Z"
})), /*#__PURE__*/React.createElement("path", {
  className: "cls-3",
  d: "m184,67.48l-106.79,32.4c-9.94,3.01-15.55,13.52-12.54,23.46l32.4,106.78c3.01,9.93,13.52,15.55,23.46,12.54l106.79-32.4c9.94-3.02,15.55-13.52,12.54-23.46l-32.4-106.78c-3.02-9.94-13.52-15.56-23.46-12.54Zm19.04,120.52c.6,1.99-1.34,4.35-4.34,5.26l-18.73,5.68-8.98-29.6-25.07,7.61,8.98,29.6-18.74,5.69c-3,.91-5.93.03-6.53-1.96l-11.74-38.69,26.28-45.51,47.13,23.23,11.74,38.69Zm1.24-44.77c-.94,1.91-2.6,3.24-4.49,3.82-1.73.52-3.66.42-5.42-.46l-51.71-25.48-28.83,49.91c-.97,1.7-2.52,2.86-4.25,3.39-1.89.57-4,.39-5.85-.68-3.54-2.04-4.75-6.57-2.7-10.11l35.76-61.93,64.14,31.61c3.67,1.8,5.18,6.24,3.37,9.91Z"
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "m243.94,257.77c6.2,3.68,11.96,8.04,17.18,12.96h0l-13.5.17-3.67-13.14h0Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "m264.89,274.5c16.21,17.07,26.31,40.03,26.64,65.33.08,5.91-.38,11.71-1.34,17.34h0l-15.29,10.24-27.66-10.98-16.44-59.88,14.1-21.79,19.98-.26h0Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "m289.06,362.83c-1.95,8.42-5,16.42-8.99,23.86h0l-2.64-16.04,11.63-7.82h0Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "m276.93,392.11c-14.26,22.88-37.82,39.45-65.39,44.31h0l-14.98-12.32-.41-32,50.18-29.88,27.67,11.99,2.93,17.89h0Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "m206.48,437.18c-3.45.42-6.95.66-10.51.71-5.39.07-10.68-.32-15.85-1.1h0l14.25-9.63,12.11,10.03h0Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "m173.06,435.44c-26.88-6.19-49.6-23.63-62.81-47.13h0l5.79-18.6,28.12-10.44,46.27,31.65.17,32.75-17.55,11.77h0Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "m107.22,382.45c-4.11-8.64-6.98-17.98-8.36-27.8h0l13.68,12.58-5.31,15.22h0Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "m98.09,347.14c-.1-1.59-.16-3.19-.18-4.81-.36-28.08,11.37-53.58,30.35-71.54h0l19.71-.26,14.44,24.25-19.07,58.7-27.89,9.43-17.36-15.78h0Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "m132.87,266.7c6.55-5.46,13.84-10.08,21.68-13.68h0l-4.9,13.46-16.79.22h0Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "m193.46,244.27c15.58-.2,30.35,3.32,43.49,9.73h0l4.76,17.69-12.76,19.74-61.42.79-14.87-23.09,6.35-18.03h0c10.68-4.26,22.3-6.68,34.45-6.84h0Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "m194.59,386.33l-46.77-32.15,19.08-57.7,59.73-.77,15.92,62.03-47.97,28.59h0Z"
})), /*#__PURE__*/React.createElement("g", {
  className: "cls-4"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-6",
  d: "m447.97,230.84c0,10.14,8.22,18.36,18.35,18.36h123c10.14,0,18.35-8.22,18.35-18.36v-10.09h-159.7v10.09Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-6",
  d: "m595.56,197.27h-135.46c-6.69,0-12.12,3.62-12.12,8.09s5.43,8.09,12.12,8.09h135.46c6.69,0,12.12-3.62,12.12-8.09s-5.43-8.09-12.12-8.09Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-6",
  d: "m553.07,146.26h-4.6c-.7-.65-1.63-1.05-2.66-1.05s-1.96.4-2.66,1.05h-8.26c-.7-.65-1.63-1.05-2.66-1.05s-1.96.4-2.66,1.05h-8.26c-.7-.65-1.63-1.05-2.66-1.05s-1.96.4-2.66,1.05h-8.26c-.7-.65-1.63-1.05-2.66-1.05s-1.97.41-2.67,1.06c-30.08.07-54.43,18.48-54.43,41.19h159.7c0-22.75-24.45-41.2-54.6-41.2Z"
})), /*#__PURE__*/React.createElement("g", {
  className: "cls-4"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-7",
  d: "m316.76,275.88c-12.41.19-20.25-7.02-23.37-13.64h0c-3.31-6.61-3.34-12.54-3.37-13.02h0c-.07-3.15,2.45-5.73,5.6-5.79h0c3.14-.06,5.74,2.46,5.79,5.61h0s.01.78.3,2.37h0c.27,1.57.85,3.7,1.86,5.67h0c2.23,3.9,4.92,7.21,13.2,7.4h0c7.9-.18,10.28-2.93,12.24-6.07h0c1.84-3.23,2.04-7.36,2.02-7.96h0v-.24h0l.24-157.43h.01c0-3.14,2.55-5.69,5.7-5.69h0c3.14,0,5.69,2.56,5.69,5.71h0l-.24,157.65s0,.01,0,.12h0c-.03,1.8-.2,7.4-3.45,13.36h0c-3.12,6.06-10.56,11.97-21.7,11.97h0c-.17,0-.35,0-.52,0h0Zm14.26-25.69c0-.16,0-.13,0,0h0Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-7",
  d: "m258.58,157.46c7.81,0,14.7,3.76,19,9.52h.29c4.3-5.76,11.19-9.52,19.01-9.52s14.7,3.76,19.01,9.52h.29c4.3-5.76,11.18-9.52,19.01-9.52s14.7,3.76,19,9.52h.29c4.3-5.76,11.18-9.52,19-9.52s14.7,3.76,19.01,9.52h.29c4.3-5.76,11.19-9.52,19-9.52s14.7,3.76,19.01,9.52h1.61c-13.84-40.37-52.03-69.44-97.1-69.44s-83.26,29.06-97.1,69.44h1.37c4.3-5.76,11.18-9.52,19.01-9.52Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-7",
  d: "m239.23,108.28c0-3.56,4.82-13.99,6.42-13.99,1.5,0,6.43,10.43,6.43,13.99s-2.88,6.42-6.43,6.42-6.42-2.87-6.42-6.42Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-7",
  d: "m416.87,108.28c0-3.56,4.81-13.99,6.42-13.99,1.49,0,6.42,10.43,6.42,13.99s-2.88,6.42-6.42,6.42-6.42-2.87-6.42-6.42Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-7",
  d: "m263.84,85.1c0-3.56,4.81-13.99,6.42-13.99,1.49,0,6.42,10.43,6.42,13.99s-2.87,6.42-6.42,6.42-6.42-2.87-6.42-6.42Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-7",
  d: "m301.3,85.1c0-3.56,4.81-13.99,6.42-13.99,1.49,0,6.42,10.43,6.42,13.99s-2.87,6.42-6.42,6.42-6.42-2.87-6.42-6.42Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-7",
  d: "m354.09,85.1c0-3.56,4.82-13.99,6.42-13.99,1.49,0,6.42,10.43,6.42,13.99s-2.88,6.42-6.42,6.42-6.42-2.87-6.42-6.42Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-7",
  d: "m391.54,85.1c0-3.56,4.81-13.99,6.42-13.99,1.5,0,6.42,10.43,6.42,13.99s-2.87,6.42-6.42,6.42-6.42-2.87-6.42-6.42Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-7",
  d: "m370.85,64.41c0-3.55,4.81-13.99,6.42-13.99,1.49,0,6.42,10.44,6.42,13.99s-2.88,6.42-6.42,6.42-6.42-2.88-6.42-6.42Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-7",
  d: "m418.64,64.41c0-3.55,4.82-13.99,6.42-13.99,1.49,0,6.42,10.44,6.42,13.99s-2.87,6.42-6.42,6.42-6.42-2.88-6.42-6.42Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-7",
  d: "m237.81,64.41c0-3.55,4.82-13.99,6.42-13.99,1.5,0,6.42,10.44,6.42,13.99s-2.87,6.42-6.42,6.42-6.42-2.88-6.42-6.42Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-7",
  d: "m284.53,64.41c0-3.55,4.82-13.99,6.42-13.99,1.49,0,6.42,10.44,6.42,13.99s-2.87,6.42-6.42,6.42-6.42-2.88-6.42-6.42Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-7",
  d: "m328.05,64.41c0-3.55,4.81-13.99,6.42-13.99,1.49,0,6.42,10.44,6.42,13.99s-2.88,6.42-6.42,6.42-6.42-2.88-6.42-6.42Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-7",
  d: "m263.84,34.68c0-3.56,4.81-13.99,6.42-13.99,1.49,0,6.42,10.43,6.42,13.99s-2.87,6.42-6.42,6.42-6.42-2.88-6.42-6.42Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-7",
  d: "m301.3,34.68c0-3.56,4.81-13.99,6.42-13.99,1.49,0,6.42,10.43,6.42,13.99s-2.87,6.42-6.42,6.42-6.42-2.88-6.42-6.42Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-7",
  d: "m354.09,34.68c0-3.56,4.82-13.99,6.42-13.99,1.49,0,6.42,10.43,6.42,13.99s-2.88,6.42-6.42,6.42-6.42-2.88-6.42-6.42Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-7",
  d: "m391.54,34.68c0-3.56,4.81-13.99,6.42-13.99,1.5,0,6.42,10.43,6.42,13.99s-2.87,6.42-6.42,6.42-6.42-2.88-6.42-6.42Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-7",
  d: "m370.85,13.99c0-3.55,4.81-13.99,6.42-13.99,1.49,0,6.42,10.44,6.42,13.99s-2.88,6.42-6.42,6.42-6.42-2.88-6.42-6.42Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-7",
  d: "m418.64,13.99c0-3.55,4.82-13.99,6.42-13.99,1.49,0,6.42,10.44,6.42,13.99s-2.87,6.42-6.42,6.42-6.42-2.88-6.42-6.42Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-7",
  d: "m237.81,13.99c0-3.55,4.82-13.99,6.42-13.99,1.5,0,6.42,10.44,6.42,13.99s-2.87,6.42-6.42,6.42-6.42-2.88-6.42-6.42Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-7",
  d: "m284.53,13.99c0-3.55,4.82-13.99,6.42-13.99,1.49,0,6.42,10.44,6.42,13.99s-2.87,6.42-6.42,6.42-6.42-2.88-6.42-6.42Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-7",
  d: "m328.05,13.99c0-3.55,4.81-13.99,6.42-13.99,1.49,0,6.42,10.44,6.42,13.99s-2.88,6.42-6.42,6.42-6.42-2.88-6.42-6.42Z"
}))))));

function SvgTypeOfGoodLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 607.68 449.21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTypeOfGoodLogo);
export default __webpack_public_path__ + "static/media/Type-of-good-logo.095353d1a4226f04e7199594e40928c0.svg";
export { ForwardRef as ReactComponent };